export function adminSectionFromHash(hash: string, known: ReadonlyArray<{ id: string }>): string {
  const section = hash.replace(/^#/, '').split('?')[0];
  return known.some(item => item.id === section) ? section! : 'dashboard';
}

export function paymentChannelLabel(channel: unknown): string {
  if (channel === 'huifu_alipay') return '汇付天下 · 支付宝';
  if (channel === 'alipay_page') return '支付宝直连';
  return channel ? `待核实通道（${String(channel)}）` : '通道待核实';
}

export type FundsCapabilities = { alipayPayout: boolean; alipayOriginalRefund: boolean; huifuOriginalRefund: false };

export function directRefundAvailable(channel: unknown, capabilities?: FundsCapabilities): boolean {
  return channel === 'alipay_page' && capabilities?.alipayOriginalRefund === true;
}

export function transferProofError(file: { type: string; size: number; name: string }): string | undefined {
  if (!['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)) return '凭证仅支持 JPG、PNG 或 PDF';
  if (!file.size || file.size > 8_388_608) return '凭证须为非空文件，且不超过 8MB';
  if (!file.name.trim() || file.name.length > 240) return '凭证文件名须为 1～240 个字符';
  return undefined;
}

export function financialActions(module: string, status: string, role: string, capabilities?: FundsCapabilities): Array<[string, string]> {
  const actions: Array<[string, string]> = [];
  if (!['withdrawals', 'refunds'].includes(module) || !['pending_review', 'processing'].includes(status)) return actions;
  const prefix = module === 'withdrawals' ? 'withdrawal' : 'refund';
  // Refund approval is only offered in the dedicated workbench after verifying the original channel.
  if (module === 'withdrawals' && capabilities?.alipayPayout === true && ['finance', 'security_admin', 'owner'].includes(role)) {
    actions.push([`${prefix}:approve`, status === 'processing' ? '同步支付宝出款结果' : '审批并执行出款']);
  }
  if (status === 'pending_review' && ['finance', 'risk', 'security_admin', 'owner'].includes(role)) {
    actions.push([`${prefix}:reject`, '拒绝并解冻']);
  }
  return actions;
}
